import axios from '@/utils/request'
import base from '../base'
import qs from 'qs'

export function messageList(data) {
    return axios.post(`${base.url}/business/messageTemplate/list`,JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });
}
export function editmessageList(data) {
    return axios.post(`${base.url}/business/messageTemplate/edit`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });
}
export function addmessageList(data) {
    return axios.post(`${base.url}/business/messageTemplate/save`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });
}
export function findByCode(data) {
    return axios.post(`${base.url}/business/messageTemplate/findByCode`, qs.stringify(data));
}
export function delmessageList(id) {
    return axios.get(`${base.url}/business/messageTemplate/del?id=${id}`);
}
export function messageStatus(data) {
    return axios.get(`${base.url}/business/messageTemplate/status?id=${data.id}&status=${data.status}`);
}
export function getMessageChannel(data) {
    return axios.get(`${base.url}/business/messageTemplate/getChannel`);
}
export function setMessageChannel(code,prepare) {
    return axios.get(`${base.url}/business/messageTemplate/setChannel?code=${code}&prepare=${prepare}`);
}

